module.exports = __webpack_public_path__ + "media/images/new-ui-images/share-icon-circule-blue-9ea65920421929078b3543f85886cdc4.svg";